import { Command } from 'commander';
import chalk from 'chalk';
import { createRulesListCommand } from './list.js';
import { createRulesInitCommand } from './init.js';
import { createRulesApplyCommand } from './apply.js';
import { createRulesRestoreCommand } from './restore.js';
import { createRulesSyncCommand } from './sync.js';
import { createRulesInfoCommand } from './info.js';

function showRulesHelp(): void {
    console.log(chalk.bold.cyan('📋 jai1 rules') + chalk.dim(' - Quản lý rule presets cho AI agents'));
    console.log();
    console.log(chalk.bold('Các lệnh:'));
    console.log(`  ${chalk.cyan('list')}      Liệt kê các presets có sẵn`);
    console.log(`  ${chalk.cyan('info')}      Xem chi tiết một preset`);
    console.log(`  ${chalk.cyan('init')}      Khởi tạo rules từ preset`);
    console.log(`  ${chalk.cyan('apply')}     Áp dụng preset vào project`);
    console.log(`  ${chalk.cyan('sync')}      Đồng bộ rules sang các định dạng IDE`);
    console.log(`  ${chalk.cyan('restore')}   Khôi phục rules từ backup`);
    console.log();
    console.log(chalk.bold('Ví dụ:'));
    console.log(chalk.dim('  $ jai1 rules list'));
    console.log(chalk.dim('  $ jai1 rules info react-typescript'));
    console.log(chalk.dim('  $ jai1 rules init --preset=react-typescript'));
    console.log(chalk.dim('  $ jai1 rules apply react-typescript'));
    console.log();
    console.log(chalk.dim('Chạy "jai1 rules <lệnh> --help" để xem chi tiết'));
}

export function createRulesCommand(): Command {
    const rulesCommand = new Command('rules')
        .description('Manage rule presets for AI agents')
        .action(() => {
            showRulesHelp();
        });

    // Add subcommands
    rulesCommand.addCommand(createRulesListCommand());
    rulesCommand.addCommand(createRulesInitCommand());
    rulesCommand.addCommand(createRulesApplyCommand());
    rulesCommand.addCommand(createRulesRestoreCommand());
    rulesCommand.addCommand(createRulesSyncCommand());
    rulesCommand.addCommand(createRulesInfoCommand());

    return rulesCommand;
}
